import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";

/**
 * Redux selectors needed by the final-documents page (modal, auth user, uploads).
 *
 * Form id is not read from Redux here — it comes from the persisted submission
 * row via {@link resolveFaxFormId}.
 *
 * @returns Modal, user, and file-upload slice values for {@link FinalDocuments}
 */
export const useFinalDocumentsData = () => {
  const { openedModalId } = useSelector((state: RootState) => state.modal);

  const {
    singleMedicalPaOrder,
    unsubscribe,
    isLoading: isLoadingSingleMedicalPaOrder,
  } = useSelector((state: RootState) => state.singleMedicalPaOrder);

  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );

  const { downloadURL, progress } = useSelector(
    (state: RootState) => state.fileUpload,
  );

  return {
    openedModalId,
    singleMedicalPaOrder,
    unsubscribe,
    isLoadingSingleMedicalPaOrder,
    user,
    downloadURL,
    progress,
  };
};
